import { render, staticRenderFns } from "./crudSurrender.vue?vue&type=template&id=6da6f0a9&scoped=true&"
import script from "./crudSurrender.vue?vue&type=script&lang=js&"
export * from "./crudSurrender.vue?vue&type=script&lang=js&"
import style0 from "./crudSurrender.vue?vue&type=style&index=0&id=6da6f0a9&prod&lang=css&"
import style1 from "./crudSurrender.vue?vue&type=style&index=1&id=6da6f0a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6f0a9",
  null
  
)

export default component.exports